import { resolveImageUrl } from "../../utils/ImageUrl";
import ManagementPageHTML, {
  IdentityCell,
  StatusBadge,
} from "../../components/ManagementPage/ManagementPageHTML";
import type { ManagementColumn } from "../../components/ManagementPage/ManagementPageTypes";
import type { Category } from "../../models/Category";
import { Status } from "../../models/Status";
import { CategoryService } from "../../services/CategoryService";
import { useCategory } from "./Category";
import "./CategoryCss.css";

const columns: ManagementColumn<Category>[] = [
  {
    Key: "Image",
    Header: "Image",
    Render: (row) =>
      row.ImageUrl ? (
        <img
          className="management-image-preview"
          src={resolveImageUrl(row.ImageUrl)}
          alt={row.Name}
        />
      ) : (
        <span className="management-summary-icon">
          <i className="fa-solid fa-image" />
        </span>
      ),
  },
  {
    Key: "Name",
    Header: "Category",
    Render: (row) => (
      <IdentityCell Icon="fa-tags" Title={row.Name} Subtitle={row.Code} />
    ),
  },
  {
    Key: "Description",
    Header: "Description",
    Render: (row) => row.Description,
  },
  {
    Key: "Products",
    Header: "Products",
    Render: (row) => <strong>{row.ProductCount}</strong>,
  },
  {
    Key: "Status",
    Header: "Status",
    Render: (row) => <StatusBadge Status={row.Status} />,
  },
];

export default function CategoryHTML() {
  const { categories } = useCategory();
  return (
    <ManagementPageHTML
      Service={CategoryService()}
      Title="Categories"
      Eyebrow="Product organisation"
      Description="Organise products into easy-to-manage categories."
      AddLabel="Add category"
      SearchPlaceholder="Search categories"
      Rows={categories}
      Columns={columns}
      Statuses={Object.values(Status)}
      GetRowKey={(row) => row.Code}
      GetSearchText={(row) => `${row.Code} ${row.Name} ${row.Description}`}
      GetStatus={(row) => row.Status}
      Summaries={[]}
      GetSummaries={(rows, total) => [
        {
          Label: "Total categories",
          Value: total,
          Icon: "fa-tags",
          Tone: "Green",
        },
        {
          Label: "Active",
          Value: rows.filter((x) => x.Status === Status.Active).length,
          Icon: "fa-circle-check",
          Tone: "Blue",
        },
        {
          Label: "Products assigned",
          Value: rows.reduce((sum, x) => sum + x.ProductCount, 0),
          Icon: "fa-box",
          Tone: "Purple",
        },
        {
          Label: "InActive",
          Value: rows.filter((x) => x.Status === Status.InActive).length,
          Icon: "fa-circle-pause",
          Tone: "Orange",
        },
      ]}
    />
  );
}
